// Application bootstrap (doc 04 §2.4).
import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from '@/plugins'
import { pinia } from '@/plugins/pinia'
import { useAuthStore } from '@/stores/auth.store'
import '@/assets/styles/main.scss'

const app = createApp(App)
registerPlugins(app) // order: pinia → router → vuetify

// Re-hydrate an existing session (token in localStorage) before the first render,
// so route guards and the UI reflect the logged-in user even on a hard refresh.
useAuthStore(pinia)
  .restore()
  .finally(() => app.mount('#app'))
